import React  from 'react';

import UpdateProfileImageContent from "../content/UpdateProfileImageContent";

import Navbar from "../inc/Navbar";
import Footer from "../inc/Footer";

function UpdateProfileImage() {
    return(
        <>
        <Navbar />
        <UpdateProfileImageContent/>
        <Footer />        
        </>
    );
}

export default UpdateProfileImage;